import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ProductCategoriesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('product_categories'), link: '/product-categories-list' },
		{ title: t('list') }
	];

	const [productCategories, setProductCategories] = useState([]);
	let productCategoriesListData = {
		head: [t('title'), t('status'), t('operation')],
		body: productCategories.map(productCategory => [
			productCategory.productcategory_name,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (productCategory.is_active ? 'success' : 'secondary')}>
				{productCategory.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/product-categories-edit/${productCategory.productcategory_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['rtl', '', 'ltr']
	};
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchProductCategoryTitle, setSearchProductCategoryTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getProductCategories = async () => {
		let body = {
			productcategory_name: searchProductCategoryTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/productcategories/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_productcategories);
				setProductCategories(response.data.productcategories);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterProductCategories = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchProductCategoryTitle.value.trim() || null;
		setSearchProductCategoryTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getProductCategories();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('product_categories')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterProductCategories}>
						<div className="row gx-2">
							<FormField fieldKey="searchProductCategoryTitle" title={t('title')} value={searchProductCategoryTitle} isSearch={true} />						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('product_categories')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={productCategoriesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ProductCategoriesList;
